/**
 * EmailBouncedBanner - mail to the signed-in user's address is bouncing.
 *
 * Set by the email provider's bounce webhook. Until it clears, the user gets
 * none of LipaFlow's email: trial, billing and suspension notices included.
 * It clears on its own once a later email to the address is delivered.
 */
import { useState } from 'react'
import { useAuthStore } from '@lipaflow/shared'
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline'

export default function EmailBouncedBanner() {
  const user = useAuthStore((s) => s.user)
  const [dismissed, setDismissed] = useState(false)

  if (!user?.email_bounced_at || dismissed) return null

  return (
    <div
      role="alert"
      className="bg-warning-50 border-b border-warning-200 text-warning-800 px-4 py-2 flex items-start justify-between gap-3"
    >
      <div className="flex items-start gap-2 font-inter text-body-sm">
        <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0 text-warning-600" />
        <p>
          Emails to <span className="font-semibold">{user.email}</span> are not arriving, so you
          will miss trial, billing and account notices. Contact LipaFlow support to correct your
          email address.
        </p>
      </div>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="p-1 rounded hover:bg-warning-100 transition-colors"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  )
}
